<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ded">
<p class="dedf"><a class="page" id="pv"></a>For D.A. Miller,</p>
<p class="ded">whose “too close reading”</p>
<p class="ded">takes us to the inner limit of screen viewing</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-stewart-0006.vue?2374f6bc